import React from 'react';

export function Card({ title, icon, children }) {
  return (
    <div
      className="panel"
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      {icon ? (
        <div className="card-icon">
          <img src={icon} alt="Card icon image" />
        </div>
      ) : null}
      <div className="card-title">{title}</div>
      <div>{children}</div>
    </div>
  );
}
